import { useEffect, useSyncExternalStore } from "react";
import { chatHub } from "@/services/websocket/chat-hub";

/**
 * Re-renders when any watched presence changes; read with `chatHub.getPresence`.
 * Returns the version so memoized derivations can depend on it.
 */
export const usePresenceVersion = () =>
  useSyncExternalStore(
    chatHub.subscribePresenceChanges,
    chatHub.getPresenceVersion,
  );

/**
 * Watches these users' presence while the calling component is mounted. Pass
 * a stable key (the ids joined) so a re-render with the same people doesn't
 * resubscribe.
 */
export const useWatchPresence = (userIds: number[]) => {
  const key = [...new Set(userIds)].sort((a, b) => a - b).join(",");
  useEffect(() => {
    if (!key) return;
    const ids = key.split(",").map(Number);
    chatHub.watchPresence(ids);
    return () => chatHub.unwatchPresence(ids);
  }, [key]);
};
